<template>
  <div>
    <div v-if="type != 'show'">
      <div class="flex al-c">
        <div class="" v-for="(v, i) in valueList" :key="i">
          <div
            class="temp"
            :class="['li' + v.value]"
            @click="curValue = v.value"
          >
            {{ v.name }} <span v-if="curValue === v.value">(选中)</span>
          </div>
        </div>
        <!-- <el-button size="small" type="primary" @click="reset"
          >全部重置</el-button
        > -->
      </div>
      <p>选择要设置的类型，然后点击下方时间段设置预约信息</p>
    </div>
    <div v-if="setPeople && info.length > 0">
      <el-switch
        style="display: block"
        v-model="setCount"
        active-color="#13ce66"
        inactive-color="#eee"
        active-text="设置预约人数"
        inactive-text=""
      >
      </el-switch>
      <p style="m-t5">点击下方时间段设置设备的预约人数信息</p>
    </div>

    <div class="data-wrap flex">
      <div class="table-time">
        <div class="time-item" v-for="(h, index) in hours" :key="index">
          {{ h }}
        </div>
      </div>
      <div class="table-wrap" v-for="(item, i) in info" :key="i">
        <div class="table-device-item">
          <div class="device-name">{{ item.device.name }}</div>
          <div
            class="scheduling-wrap"
            :style="{
              'grid-template-rows': `repeat(${hours.length - 1},50px)`,
            }"
          >
            <div
              class="d-item"
              :class="['li' + d.v]"
              v-for="(d, k) in item.data"
              :style="{ 'grid-row-start': d.s_row, 'grid-row-end': d.e_row }"
              :key="k"
              @click="settingData(d, item.device, d.service)"
            >
              <div class="" v-if="[1, 2].includes(d.v)">
                ￥{{ getPrice(d.service) }}
              </div>
              {{ caseMap[d.v] }}
              <div v-if="d.count">已约{{ d.count }}/{{ d.max }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="编辑" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form">
        <el-form-item label="">
          <p>{{ curDevice.name }}：{{ curDate.s }}-{{ curDate.e }}</p>
          <p>已预约:{{ curDate.count }}人</p>
          <p>设备预约人数上限:{{ curDevice.max_people }}人</p>
        </el-form-item>
        <el-form-item label="修改已预约人数">
          <el-input
            v-model.number="count"
            type="number"
            placeholder="设备已预约人数"
          ></el-input>
          <div>填写设备在该时间段的预约人数</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCount">更 新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    startTime: {
      type: String,
      default: "",
    },
    changeTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "add",
    },
    setPeople: {
      type: Boolean,
      default: false,
    },
    devices: {
      type: Array,
      default: () => {
        return [];
      },
    },
    datas: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      setCount: false,
      valueList: [
        { name: "不开放", value: 0 },
        { name: "开放", value: 1 },
      ],
      caseMap: {
        0: "不开放",
        1: "闲时价",
        2: "高峰价",
        3: "已约满",
      },
      curValue: 1,
      hours: [],
      info: [], // [{ device: {}, data: [{s,e,v}] }]
      timeData: [],
      dialogVisible: false,
      curDevice: {},
      curDate: {},
      count: "",
    };
  },
  watch: {
    datas: {
      handler: function (nv, ov) {
        if (nv.length > 0) {
          //时间段
          const hourSet = new Set();
          nv.forEach((item) => {
            item.data.forEach((v) => {
              hourSet.add(v.s);
              hourSet.add(v.e);
            });
          });

          let hours = Array.from(hourSet);
          this.hours = hours.sort((a, b) => {
            return Number(
              new Date("2025/01/01 " + a + ":00").getTime() -
                new Date("2025/01/01 " + b + ":00").getTime()
            );
          });

          nv.forEach((item) => {
            let scheduling = [];

            item.data.forEach((v) => {
              let s_row = hours.indexOf(v.s) + 1;
              let e_row = hours.indexOf(v.e) + 1;
              v.s_row = s_row;
              v.e_row = e_row;
              scheduling.push(v);
            });

            item.data = scheduling;
          });
          this.info = nv;
        } else {
          this.info = [];
          this.hours = [];
        }
      },
    },
  },
  mounted() {},

  methods: {
    getPrice(service) {
      return service.price;
    },
    updateCount() {
      if (this.count === '') {
        this.$message("请填写已预约人数");
        return;
      }
      if (this.count < 0) {
        this.$message("请填写已预约人数");
        return;
      }
      if (this.count > this.curDevice.max_people) {
        this.$message("预约人数不能大于上限");
        return;
      }
      this.$axios({
        url: "/shared/deviceAppointmentRecord/setCount",
        method: "post",
        data: {
          device_id: this.curDevice.id,
          appointment_count: this.count,
          start_time: `${this.changeTime} ${this.curDate.s}:00`,
          end_time: `${this.changeTime} ${this.curDate.e}:00`,
        },
      }).then((res) => {
        if (this.count == this.curDevice.max_people) {
          this.curDate.v = 3;
        }else{
          this.curDate.v = this.curDate.service.type
        }
        this.curDate.count = this.count;
        this.dialogVisible = false;
        this.count = "";
      });
    },
    getAppointTemplate() {
      let res = this.info.map((item) => {
        let datas = item.data.filter((v) => v.e);
        let str = datas.map((t) => {
          return { e: t.e, s: t.s, v: t.v, sid: t.sid };
        });
        return {
          device_id: item.device.id,
          data: JSON.stringify(str),
        };
      });
      return res;
    },
    reset() {
      this.$confirm("确认重置所有时间段？").then((res) => {
        this.info.forEach((item) => {
          item.data.forEach((v) => {
            v.v = 1;
          });
        });
      });
    },
    settingData(time, device, service) {
      if (this.type != "show") {
        if (this.curValue === 0) {
          time.v = 0;
        } else if (this.curValue === 1) {
          time.v = service.type;
        }
      } else if (this.setCount) {
        if (time.v != 0) {
          this.curDate = time;
          this.curDevice = device;
          this.dialogVisible = true;
        }
      }
    },
    initInfo() {
      this.info = [];
      let s = Number(this.startTime.split(":")[0]);
      let e = Number(this.endTime.split(":")[0]);
      let hours = [];
      let timeData = [];
      for (let i = s; i < e; i++) {
        hours.push(this.zeroFill(i) + ":00");
        let item = {
          s: this.zeroFill(i) + ":00",
          e: this.zeroFill(i + 1) + ":00",
          v: 1,
        };
        timeData.push(item);
      }
      this.timeData = timeData;
      hours.push(this.zeroFill(e) + ":00");
      this.hours = hours;
      this.devices.forEach((item) => {
        let data = JSON.parse(JSON.stringify(timeData));
        this.info.push({ device: item, data });
      });
    },
    zeroFill(n) {
      return n < 10 ? "0" + n : n;
    },
  },
};
</script>
<style lang="less" scoped>
.data-wrap {
  overflow: auto;
  margin-top: 15px;
}
.table-wrap {
  display: flex;
  flex-wrap: nowrap;
}
.table-time {
  padding-top: 28px;
  .time-item {
    box-sizing: border-box;
    height: 50px;
  }
}
.table-device-item {
  width: 100px;
  flex-shrink: 0;
  margin-left: 5px;
  .d-item {
    box-sizing: border-box;
    border: 1px solid rgb(235, 235, 235);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
.temp {
  height: 40px;
  width: 100px;
  line-height: 40px;
  text-align: center;
  margin-right: 20px;
}
.device-name {
  box-sizing: border-box;
  height: 30px;
  padding: 5px;
  width: 100px;
  text-align: center;
}
.scheduling-wrap {
  display: grid;
  grid-template-columns: 100px;
  background-color: #f4f4f4;
}

.li0 {
  background-color: #eee;
}
.li1 {
  background-color: rgb(134, 235, 121);
}
.li2 {
  background-color: rgb(240, 193, 123);
}
.li3 {
  background-color: rgb(169, 203, 231);
}
</style>